<template>
	<div class="bg-white all margin-left padding-lr">
		<el-form :label-position="labelPosition" label-width="80px" :model="info" :rules="rules" ref="info">
			<el-form-item label="置顶区域" prop="address">
				<div class="cascadera padding-lr-sm">
					<div class="casca text-right" @click.stop="chosecit">{{ addressinfo.join(',')||'请选择置顶区域'}}</div>
					<div class="flex bg-white align-center cate pointer" v-if="ishowcity">
						<ul class="blobk300">
							<li class="pointer text-left flex align-center justify-between"
								v-for="(item,index) in provinceList" :key="index" @click="chooseProvince(item,index)">
								<div :class="item.ischeck?'text-theme':''">{{item.name}}</div>
								<i class="el-icon-arrow-right text-lg"></i>
							</li>
						</ul>
						<ul class="blobk300">
							<li class="pointer text-left flex align-center justify-between"
								v-for="(item,index) in cityList" :key="index" @click="chooseCity(item,index)">
								<div :class="item.ischeck?'text-theme':''">{{item.name}}</div>
							</li>
						</ul>
					</div>
				</div>
			</el-form-item>
			<el-form-item label="置顶时间" prop="category">
				<el-select v-model="info.time" placeholder="请选择置顶时间">
					<el-option :label="item.name" v-for="(item,index) in timelist" :key="index" :value="item.num">
					</el-option>
				</el-select>
			</el-form-item>
			


			<el-button class="creat" type="primary" @click="submitForm()">保存提交</el-button>
			
		</el-form>
		<div class="text-left margin-top-sm">	
			<div v-html="careful"></div>
		</div>
	</div>
</template>

<script>
	import Bus from '@/store/eventBus.js'
	export default {
		data() {
			return {
				//选择城市
				addarea: [],
				addressinfo: [], //展示城市类别
				ishowcity: false, //
				provinceList: [], // 省列表
				cityList: [], //市
				careful:'',
				labelPosition: 'left',
				info: {
					time:''
				},
				type:1,
				pid:0,//帖子id
				rules: {}, //表单校验规则
				timelist: [{
						name: '24小时(1天)',
						num:1
					},
					{
						name: '48小时(2天)',
						num:2
					},
					{
						name: '72小时(3天)',
						num:3
					}
				]
			}
		},
		created() {
			Bus.$on('setplacement',data=>{
				this.type = data.type
				this.pid = e.id
			})
			this.postOperationGetColumn()
			this.getcity()
		},
		methods: {
			postOperationGetColumn(){
				this.ajax('get', '/api/agreement/getInfo', {
					type:9,
				}, res => {
					if (res.status == 200) {
						this.careful = res.data.content
					}
				})
			},
			//获取城市列表
			getcity() {
				this.ajax('get', '/api/work/getCityList', {}, res => {
					if (res.status == 200) {
						let list = res.data;
						list.forEach(item => {
							let obj = {
								id: 0,
								level: 1,
								pid: item.id,
								name: '不限',
							}
							if (item.children) {
								if (item.children.length > 1) {
									item.children = [obj, ...item.children]
								}
							} else {
								item.children = [obj]
							}

							item.children.map(plp => {
								plp.ischeck = false
							})
						})
						this.provinceList = list;
						this.cityList = list[0].children
					}
				})
			},
			//展示城市选择器
			chosecit() {
				this.ishowcity = !this.ishowcity
			},
			//选择省
			chooseProvince(item, index) {
				this.provinceIndex = index;
				this.cityList = item.children
				// this.cityIndex = null;
			},
			//选择市
			chooseCity(item, index) {
				let havezoon = 0 //
				let haveone = 0
				this.addarea.map(item => {
					if (item.lever == 0) {
						havezoon++
					}
					if (item.lever != 0) {
						haveone++
					}
				})
				console.log(havezoon,haveone);
				if (!item.ischeck) {
					//选择的不限并且已经有两个省或直辖市 || 选择的直辖市并且已经有两个省或直辖市
					if (item.id == 0 && havezoon == 2 || this.cityList.length == 1 && havezoon == 2) {
						this.$message.info('最多添加2个省或直辖市')
					}
					//选择的市并且已经有3个市并且不是直辖市
					if (item.id != 0 && haveone == 3 && this.cityList.length > 1) {
						this.$message.info('最多添加3个市')
					}
					if ((item.id == 0 && havezoon != 2) || (this.cityList.length == 1 && havezoon != 2) || (item.id != 0 &&
							haveone != 3)) {
						item.ischeck = !item.ischeck
						if (this.cityList.length == 1) {
							let arr = {
								lever: 0,
								...item
							}
							this.addarea.push(arr)
						} else {
							if (item.id == 0) {
								let arr = {
									lever: 0,
									...item
								}
								this.addarea.push(arr)
							} else {
								let arr = {
									lever: 1,
									...item
								}
								this.addarea.push(arr)
							}
						}

					}
				} else {
					this.addarea.map((clc, index) => {
						if (clc.name == item.name) {
							item.ischeck = !item.ischeck
							this.addarea.splice(index, 1)
						}
					})
				}
				this.addressinfo = []
				this.addarea.map(ele => {
					this.addressinfo.push(ele.name)
				})
			},
			//保存提交
			submitForm() {
				this.$refs.info.validate((valid) => {
					if (valid) {
						this.getInfotop()
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			getInfotop(){
				this.ajax('get', '/api/top/getInfo',{
					cnum:this.addarea.length,
					daynum:this.info.time
				}, res => {
					if (res.status == 200) {
						this.sub(res.data.top_integral)
					} else {
						this.$message(res.msg);
					}
				})
			},
			sub(top_integral){
				if(this.addarea.length == 0){
					this.$message.info('请添加置顶城市')
				}
				let area = this.addressinfo
				
				let data = {
					area:area.join(','),
					time:this.info.time,
					type:this.type,
					integral:top_integral
				}
				if(this.type == 0){
					data.aid = this.pid
				}
				this.ajax('post', '/api/top/addTop',data, res => {
					
					if (res.status == 200) {
						this.$message.success(res.msg);
					} else {
						this.$message(res.msg);
					}
				})
			}
		}
	}
</script>

<style scoped lang="less">
	.all {
		width: 921px;
		height: 878px;
		background: #FFFFFF;
		box-shadow: -4px 3px 19px 1px rgba(204, 204, 204, 0.2000);
		border-radius: 20px;
		padding-top: 40px;
	}
	.el-cascader,
	.el-select {
		width: 740px;
		height: 54px;
	}

	.cascadera {
		min-height: 54px;
		position: relative;

		.casca {
			padding: 0 10px;
			width: 100%;
			height: 54px;
			line-height: 54px;
			border: 1px solid #E6E6E6;
			border-radius: 8px;
		}

		ul,
		li {
			list-style: none;
		}

		.cate {
			overflow: hidden;
			position: absolute;
			top: 54px;
			z-index: 9;

			.blobk300 {
				height: 200px;
				min-width: 180px;
				box-sizing: border-box;
				overflow: auto;
				line-height: 35px;
				border: 1px solid #E6E6E6;
			}
		}

		::-webkit-scrollbar {
			width: 5px;
			/*高宽分别对应横竖滚动条的尺寸*/
			height: 1px;
		}

		::-webkit-scrollbar-thumb {
			/*滚动条里面小方块*/
			border-radius: 10px;
			box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
			background: #666;
			transition: background 1s;
		}

		::-webkit-scrollbar-track {
			/*滚动条里面轨道*/
			box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.1);
			border-radius: 10px;
			background: #ededed;
		}
	}
	.creat {
		width: 383px;
		height: 46px;
		background: #09827B;
		box-shadow: 3px 4px 38px 2px rgba(9, 130, 123, 0.2000);
		border-radius: 23px;
		margin-top: 40px;
		margin-bottom: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/my/setplacement/index.vue